import React, { Component } from "react";
import _ from "lodash";
import { ButtonGroup, Button } from "../../components";
import { multiLanguage } from "../../hoc";
import SitePlanImage from "../../data/PhuketLagunaPark2/sitePlan/svg";
import Popup from "./components/popup";

@multiLanguage()
export default class Siteplan extends Component {
  state = {
    type: "all",
    popupHover: "",
  };
  hover = () => {
    const allEl = document.querySelectorAll("#floorplan g");
    console.log("allEl", allEl);
    for (let i = 0; i < allEl.length; i += 1) {
      allEl[i].addEventListener("mouseover", this.handleUnitHover);
    }
  };
  unhover = () => {
    const allEl = document.querySelectorAll("#floorplan g");
    for (let i = 0; i < allEl.length; i += 1) {
      allEl[i].addEventListener("mouseout", this.handleUnitUnHover);
    }
  };

  handleUnitUnHover = (e) => {
    this.setState({
      popupHover: "",
    });
  };

  handleUnitHover = (e) => {
    const currentHoverType = e.target.parentElement.id;
    console.log("allEl handleUnitHover", {
      currentHoverType,
      e: e.target.parentElement,
    });
    this.setState({
      popupHover: currentHoverType,
    });
  };
  componentDidUpdate() {
    this.hover();
    this.unhover();
  }
  renderPopup = () => {
    const { descriptions, t } = this.props;
    const { popupHover, type } = this.state;
    const mapHoverData = _.map(descriptions, (item) => {
      const getTypePopup = _.get(item, "value");
      const getDataPopup = _.get(item, "title");
      const activePopup = getTypePopup === popupHover ? "active" : "";
      console.log("renderPopup", item);
      return (
        <Popup
          title={t(getTypePopup)}
          data={t(getDataPopup)}
          active={activePopup}
          onclick={this.handleUnitHover}
        />
      );
    });
    return mapHoverData;
  };
  render() {
    const { t, dataSitePlan, currentLanguage, page } = this.props;
    const { type } = this.state;
    console.log("render-siteplan", type);
    return (
      <div className={`section-siteplan ${page} site-plan-has-menu`}>
        <SitePlanImage currentLang={currentLanguage} selectedType={type} />
        {this.renderPopup()}
        <div className="siteplan-container-buttongroup">
          <ButtonGroup
            value={type}
            items={dataSitePlan}
            onChange={(value) =>
              this.setState({ type: value, popupHover: value })
            }
            direction="horizontal"
            renderItem={({ value, title, active, onClick }) => {
              return (
                <Button
                  key={value}
                  type="secondary"
                  active={active}
                  activeStyle={{ backgroundColor: "#00a9a5" }}
                  hoverStyle={{ backgroundColor: "#00a9a5" }}
                  defaultStyle={{
                    marginRight: "1px",
                    textTransform: "uppercase",
                  }}
                  onClick={onClick}
                >
                  {t(title)}
                </Button>
              );
            }}
          />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/PhuketLagunaPark2/Siteplan.js